/* Material Symbols setup */
.material-symbols-outlined {
  font-family: "Material Symbols Outlined";
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24;
  font-size: 20px;
  line-height: 1;
  vertical-align: middle;
}

:host {
  --topbar-bg: #17223a;
  --topbar-fg: #ffffff;
  --topbar-height: 60px;
  --font-sans: system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, 'Helvetica Neue', Arial, 'Noto Sans', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  --warn: #f4c84a;
  --error: #ef5350;
  --info: #64b5f6;
  --success: #66bb6a;
  --muted: rgba(255,255,255,0.65);
  --muted-2: rgba(255,255,255,0.45);
  --badge-bg: #e53935;
  --badge-notif: #d1533f;
  --badge-msg: #62b7a2;
  /* Motion + easing tokens */
  --ease-out: cubic-bezier(0.2, 0.8, 0.2, 1);
  --anim-fast: 160ms;
  --anim-medium: 220ms;
  display: contents;
}

.topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: var(--topbar-height);
  background: var(--topbar-bg);
  color: var(--topbar-fg);
  z-index: 1000;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  column-gap: 16px;
  padding: 0 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  overflow: visible;
  box-sizing: border-box;
}

.topbar .left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.logo {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  text-decoration: none;
  border-radius: 6px;
  color: inherit;
  transition: background-color var(--anim-fast) var(--ease-out), border-color var(--anim-fast) var(--ease-out);
}

.logo-mark {
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background: #0e1528;
  border: 1px solid rgba(255, 255, 255, 0.18);
  font: 700 12px/1 system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, "Helvetica Neue", Arial, "Noto Sans";
}

.menu {
  display: flex;
  align-items: center;
  gap: 4px;
}

.dropdown {
  position: relative;
}

.nav-item {
  color: var(--topbar-fg);
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  text-decoration: none;
  font: 500 14px/1.2 var(--font-sans);
  transition: background-color var(--anim-fast) var(--ease-out), border-color var(--anim-fast) var(--ease-out), transform var(--anim-fast) var(--ease-out), box-shadow var(--anim-fast) var(--ease-out);
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.12);
}

.nav-item:active {
  transform: translateY(1px);
}

@media (prefers-reduced-motion: reduce) {
  .nav-item, .logo {
    transition: none;
  }
}
.dropdown-menu {
  /* Base positioning and box */
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 240px;
  max-height: 60vh;
  overflow: auto;
  overflow-x: hidden;
  background: #0e1528;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  padding: 8px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35), 0 2px 10px rgba(0, 0, 0, 0.25);
  z-index: 1100;
  color: var(--topbar-fg);
  font-family: var(--font-sans);
  /* Animated visibility (no layout impact since absolute) */
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(-6px) scale(0.98);
  transition: opacity var(--anim-fast) var(--ease-out), transform var(--anim-medium) var(--ease-out), visibility 0s linear var(--anim-fast);
}

.dropdown-toggle[aria-expanded=true] + .dropdown-menu {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: none;
  transition: opacity var(--anim-fast) var(--ease-out), transform var(--anim-medium) var(--ease-out), visibility 0s linear 0s;
}

.dropdown-right {
  right: 0;
  left: auto;
}

.dropdown-menu .item {
  display: flex;
  align-items: center;
  gap: 10px;
  background: transparent;
  border: 0;
  color: var(--topbar-fg);
  text-decoration: none;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  font: 500 14px/1.2 var(--font-sans);
  text-align: left;
  transition: background-color var(--anim-fast) var(--ease-out);
}

.dropdown-menu .item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.dropdown-menu .section-title {
  padding: 6px 10px 4px;
  color: var(--muted);
  font: 600 12px/1.2 var(--font-sans);
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.dropdown-menu.menu-notifications, .dropdown-menu.menu-messages {
  width: 360px;
  max-width: calc(100vw - 24px);
}

.dropdown-menu, .apps-list, .apps-sublinks {
  overscroll-behavior: contain;
  overscroll-behavior-y: contain;
}

@media (prefers-reduced-motion: reduce) {
  .dropdown-menu {
    transition: none;
    transform: none;
  }
}
.dropdown-menu, .apps-list, .apps-sublinks {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.dropdown-menu::-webkit-scrollbar, .apps-list::-webkit-scrollbar, .apps-sublinks::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.dropdown-menu::-webkit-scrollbar-track, .apps-list::-webkit-scrollbar-track, .apps-sublinks::-webkit-scrollbar-track {
  background: transparent;
}

.dropdown-menu::-webkit-scrollbar-thumb, .apps-list::-webkit-scrollbar-thumb, .apps-sublinks::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.22);
  border-radius: 8px;
  border: 2px solid transparent;
  background-clip: content-box;
}

.dropdown-menu::-webkit-scrollbar-thumb:hover, .apps-list::-webkit-scrollbar-thumb:hover, .apps-sublinks::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.34);
}

.dropdown-menu.menu-apps {
  width: 640px;
  max-width: calc(100vw - 24px);
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  column-gap: 12px;
  max-height: 70vh;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.apps-list {
  overflow: auto;
  padding-right: 4px;
  max-height: calc(70vh - 16px);
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
}

.apps-sublinks {
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  padding-left: 12px;
  overflow: auto;
  max-height: calc(70vh - 16px);
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
}

.item-app {
  position: relative;
  display: grid;
  grid-template-columns: 28px 1fr;
  column-gap: 10px;
  padding: 10px;
  border-radius: 8px;
  color: var(--topbar-fg);
  text-decoration: none;
  cursor: pointer;
}

.item-app:hover {
  background: rgba(255, 255, 255, 0.06);
}

.item-app.is-active {
  background: rgba(255, 255, 255, 0.08);
}

.item-app .material-symbols-outlined {
  font-size: 20px;
  opacity: 0.9;
}

.item-app .label {
  font: 600 14px/1.25 var(--font-sans);
}

.item-app .desc {
  color: var(--muted);
  font: 400 11px/1.35 var(--font-sans);
  margin-top: 2px;
}

.apps-sublinks .pane {
  display: none;
}

.apps-sublinks .pane.active {
  display: block;
  animation: s2s-fade-in var(--anim-fast) var(--ease-out);
}

.apps-sublinks .item {
  padding: 10px;
  display: grid;
  grid-template-rows: auto;
  row-gap: 0;
  align-content: center;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.apps-sublinks .item.is-active {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 8px;
}

.apps-sublinks .item:has(.sub-desc) {
  grid-template-rows: auto auto;
  row-gap: 2px;
}

.apps-sublinks .item .sub-label {
  font: 600 13px/1.25 var(--font-sans);
  color: #fff;
}

.apps-sublinks .item .sub-desc {
  font: 400 11px/1.3 var(--font-sans);
  color: var(--muted);
}

.menu-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.12);
  margin: 8px 0;
  border-radius: 1px;
}

@keyframes s2s-fade-in {
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.menu-header, .menu-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 6px 8px;
}

.menu-header .title {
  color: #fff;
  font: 700 13px/1.2 var(--font-sans);
}

.link-btn {
  background: transparent;
  border: 1px solid transparent;
  color: var(--muted);
  font: 600 12px/1.2 var(--font-sans);
  padding: 4px 6px;
  border-radius: 6px;
  cursor: pointer;
}

.link-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.alert-item, .msg-item {
  display: grid;
  grid-template-columns: 28px 1fr;
  column-gap: 10px;
  padding: 10px;
  margin: 2px 0;
  border-radius: 8px;
  color: var(--topbar-fg);
  text-decoration: none;
}

.alert-item:hover, .msg-item:hover {
  background: rgba(255, 255, 255, 0.06);
}

.alert-item.unread, .msg-item.unread {
  background: rgba(255, 255, 255, 0.04);
}

.alert-item .icon, .msg-item .avatar {
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  font-size: 18px;
}

.alert-item .icon.warning {
  color: var(--warn);
  border-color: rgba(244, 200, 74, 0.4);
}

.alert-item .icon.error {
  color: var(--error);
  border-color: rgba(239, 83, 80, 0.4);
}

.alert-item .icon.info {
  color: var(--info);
  border-color: rgba(100, 181, 246, 0.4);
}

.alert-item .icon.success {
  color: var(--success);
  border-color: rgba(102, 187, 106, 0.4);
}

.item-body {
  font-family: var(--font-sans);
}

.item-body .row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.item-body .title {
  font: 600 13px/1.25 var(--font-sans);
}

.item-body .snippet, .item-body .text {
  color: var(--muted);
  font-size: 12px;
  margin-top: 2px;
  font-family: var(--font-sans);
}

.item-body .time {
  color: var(--muted-2);
  margin-left: auto;
  font-size: 12px;
}

.msg-item .avatar {
  font: 700 12px/1 system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, "Helvetica Neue", Arial, "Noto Sans";
}

.msg-item .unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--info);
  margin-left: auto;
}

.center {
  min-width: 0;
}

.search {
  position: relative;
  display: grid;
  grid-template-columns: 28px 1fr;
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  height: 36px;
  padding: 0 8px 0 6px;
  transition: background-color var(--anim-fast) var(--ease-out), border-color var(--anim-fast) var(--ease-out), box-shadow var(--anim-fast) var(--ease-out);
}

.search .icon {
  display: inline-grid;
  place-items: center;
  color: rgba(255, 255, 255, 0.85);
  transition: color var(--anim-fast) var(--ease-out);
}

.search input[type=search] {
  width: 100%;
  background: transparent;
  border: 0;
  outline: none;
  color: var(--topbar-fg);
  font: 500 14px/1.1 var(--font-sans);
  transition: color var(--anim-fast) var(--ease-out);
}

.search input::placeholder {
  color: rgba(255, 255, 255, 0.75);
}

.search:focus-within {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.32);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25), 0 0 0 2px rgba(255, 255, 255, 0.06) inset;
}

.search:focus-within .icon {
  color: #fff;
}

@media (prefers-reduced-motion: reduce) {
  .search {
    transition: none;
  }
  .search .icon, .search input[type=search] {
    transition: none;
  }
}
.right {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: max-content;
}

.icon-btn {
  display: inline-grid;
  place-items: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 8px;
  color: var(--topbar-fg);
  cursor: pointer;
  position: relative;
  transition: background-color var(--anim-fast) var(--ease-out), border-color var(--anim-fast) var(--ease-out), transform var(--anim-fast) var(--ease-out), box-shadow var(--anim-fast) var(--ease-out);
  overflow: hidden;
}

.icon-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.12);
}

.icon-btn:active {
  transform: scale(0.96);
}

.icon-btn::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transform: scale(0.4);
  transition: opacity var(--anim-fast) var(--ease-out), transform var(--anim-medium) var(--ease-out);
  mix-blend-mode: overlay;
  pointer-events: none;
}

.icon-btn:active::before {
  opacity: 0.18;
  transform: none;
}

.icon-btn .material-symbols-outlined {
  font-size: 20px;
}

.icon-btn[data-count]::after {
  content: attr(data-count);
  position: absolute;
  top: -1px;
  right: -1px;
  min-width: 12px;
  height: 12px;
  padding: 0 3px;
  border-radius: 9999px;
  background: var(--badge-bg);
  color: #fff;
  border: 1px solid var(--topbar-bg);
  font: 800 8px/9px var(--font-sans);
  display: grid;
  place-items: center;
  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.15);
}

.icon-btn.badge-notifications[data-count]::after {
  background: var(--badge-notif);
}

.icon-btn.badge-messages[data-count]::after {
  background: var(--badge-msg);
}

.avatar {
  display: inline-grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.12);
  color: var(--topbar-fg);
  font: 700 12px/1 system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, "Helvetica Neue", Arial, "Noto Sans";
  cursor: pointer;
  margin-left: 8px;
}

.avatar.has-image {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: transparent;
}

@media (max-width: 480px) {
  .avatar {
    margin-left: 4px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .icon-btn {
    transition: none;
  }
  .icon-btn::before {
    transition: none;
  }
}
:host {
  --s2s-ribbon-bg: #3b404c;
  --s2s-ribbon-fg: #fff;
  --s2s-ribbon-base: 10px;
}

.s2s-ribbon {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1002;
  background: var(--s2s-ribbon-bg);
  height: var(--s2s-ribbon-base);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.35);
  box-sizing: border-box;
  color: var(--s2s-ribbon-fg);
}

.s2s-ribbon-content {
  position: absolute;
  right: 8px;
  top: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.s2s-ribbon .badge {
  background: var(--s2s-ribbon-bg);
  border: 0;
  color: var(--s2s-ribbon-fg);
  border-radius: 9999px;
  padding: 2px 10px;
  font: 600 10px/1.2 var(--font-sans);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.s2s-ribbon .account, .s2s-ribbon .env, .s2s-ribbon .role {
  white-space: nowrap;
}

.s2s-ribbon .role {
  background: transparent;
  border: 0;
  color: var(--s2s-ribbon-fg);
  border-radius: 9999px;
  padding: 0;
  font: 600 9px/1.2 var(--font-sans);
  opacity: 0.95;
}

.topbar {
  top: var(--s2s-ribbon-height, 0px) !important;
}
